app.service('loginView', function (emailInvalid, validate, ajaxOrder, front, csrfToken,
	loading, passwordInvalid, agreementsSubmit, modal, pageConfig, message) {
	var count = 0;
	var config = false;
	function setElements() {
	}
	function setEvents() {

	}

	function redirectToTargetUrl(url) {
		if (url.startsWith("/") || url.startsWith("http")) {
			if (url.includes("j_spring_security_check")) {
				$.post({
					url: url,
					success: redirectToTargetUrl
				});
			} else {
				changePage(url);
			}
		} else {
			loading.reload({ soft: false });
		}
	}
	function changePage(url) {
		if (front.page() === 'login' && testAB.getVar('ajax-order2') === 'B' && front.getParam('ajaxOrder')) {
			ajaxOrder.get({
				href: url,
				scroll: '#cart-retrieve, #shop-delivery .row-delivery-point:visible, #home-delivery .row-delivery-point:visible, form'
			});
		} else {
			loading.redirect(url);
		}
	}

	function send($form) {
		loading.start();
		UA.push({ 'event': 'login' });
		$form.ajaxSubmit({
			success: redirectToTargetUrl,		// odpowiedzią jest string z urlem
			statusCode: {
				403: function () {
					count++;
					if (count > 2) {
						modal.alert('Nieudana próby wysłania formularza. Możliwe problemy z obsługą ciasteczek lub blokowaniem treści.', function () {
							loading.reload({ soft: false });
						});
					} else {
						csrfToken.refresh(function () {
							send($form);
						});
					}
				},
				500: function () {
					loading.stop();
					modal.alert('Nieudana próba wysłania formularza. Spróbuj ponownie później.')
				}
			}
		});
	}

	function guestLogin() {
		loading.start();
		$.ajax({
			url: '/guest_j_spring_security_check.ltr',
			type: 'POST',
			success: function (html) {
				changePage(html);
			},
			error: function () {
				modal.alert('Nie udało się przejść do zakupów w trybie gość. Spróbuj ponownie później');
			}
		});
	}

	function init() {
		setElements();
		setEvents();
		config = pageConfig.getData('order');
		validate.task('login', send);
		validate.task('registration', function ($form) {
			emailInvalid.check(function () {
				send($form);
			})
		});

		agreementsSubmit.init($('#registration-box form'), $('#registration-box form').find("input[name=permissionToProcessingAccepted]"));
		emailInvalid.init($('#email'), $('#email-invalid-text'), $('#email').closest('.row-input'));
		passwordInvalid.init($('#password'), $('#password').parents().find('.password-invalid'), $('#password').closest('.row'), $('#email'));

		$('.js-register-button').click(function () {
			var $form = $(this).closest('form');
			if ($form.valid()) {
				$form.submit();
			}
		});
		if (config.guestModeEnabled) {

			$('.js-register-full').click(function () {
				$('#registration-box').attr('data-view', 'b');
			});
			$('.js-guest-mode').click(function () {
				UA.push({
					event: 'KupBezKontaClick',
					eventParameters: {
						eventCategory: 'Ecommerce',
						eventAction: 'click',
						eventLabel: 'Kup bez konta'
					}
				});

				if (config.guestCMSModal && $('#guest-block-custom-html').length) {
					modal.generate({
						id: 'modal-guest-cms-block',
						content: $('#guest-block-custom-html').html(),
						buttons: [
							{
								text: 'Anuluj',
								cssClass: 'cancel',
								click: function () {
									modal.close();
								}
							},
							{
								text: 'Rezygnuję z promocji i idę dalej',
								cssClass: 'confirm',
								click: function () {
									modal.close();
									guestLogin();
								}
							}
						]
					})
				} else {
					guestLogin();
				}
			});
			$('.js-disabled-guest-mode').click(function () {
				modal.open('no-guest-mode');
				UA.push({
					event: 'SprawdzSzczegolyClick',
					eventParameters: {
						eventCategory: 'Ecommerce',
						eventAction: 'click',
						eventLabel: 'Sprawdz Szczegoly'
					}
				});
			});

		} else {


		}

		if (config.nklSessionExpired) {
			message.get('nkl-session-expired-message').then(function (html) {
				modal.generate({
					id: 'nkl-error',
					content: html
				});
			});
		}
	}
	return {
		init
	};
});
